import { generateId } from "@evergis/api";
import { ComplexOptionText, IconTypesKeys, IOption } from "@evergis/ui";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AlignmentOption, ProjectInfoBlock, ProjectInfoBlockType } from "../types";

export function useAddHandlers(add: (block: ProjectInfoBlock) => void, setItems, items) {
  const handlers = useMemo(
    () => ({
      mde: (index?: number) => {
        const newItem = { id: generateId(), type: ProjectInfoBlockType.MDE, value: "" };

        if (!index) {
          return add(newItem);
        }

        const newItems = [...items];

        newItems.splice(index, 0, newItem);
        setItems(newItems);
      },
      gallery: (index?: number) => {
        const newItem = {
          id: generateId(),
          type: ProjectInfoBlockType.GALLERY,
          value: { items: [], width: 832, height: 468, alignment: AlignmentOption.Center },
        };

        if (!index) {
          return add(newItem);
        }

        const newItems = [...items];

        newItems.splice(index, 0, newItem);
        setItems(newItems);
      },
    }),
    [add, setItems, items],
  );

  const { t } = useTranslation("dialogs");

  const options = useMemo(
    () => [
      {
        value: "mde",
        icon: "text_editor" as IconTypesKeys,
        text: t("editResource.textBlock"),
      },
      {
        value: "gallery",
        icon: "image" as IconTypesKeys,
        text: t("editResource.imageGallery"),
      },
    ],
    [t],
  );

  const onSelect = useCallback(
    (optionItems: IOption<ComplexOptionText>[], index?: number) => {
      const [{ value }] = optionItems;

      if (handlers[value]) {
        handlers[value](index);
      }
    },
    [handlers],
  );

  return {
    options,
    onSelect,
  };
}
